<template>
    <div>
        <b-alert
            variant="success"
            class="rounded-0 border-0 mb-0 text-center"
            v-if="enableRequestLive"
            show
        >
            <div v-if="requestedLive">
                <font-awesome-icon icon="fa-light fa-check" />
                Request sent
                <div class="small my-2">
                    You're interested in the user so you'll get notified when
                    they go live
                </div>
            </div>
            <div v-else>
                <div class="d-flex align-items-center justify-content-between">
                    <h5 class="mb-0">
                        <b-spinner type="grow" small variant="success" />
                        Online
                    </h5>

                    <div class="my-2 small">You can ask them to go live</div>
                </div>

                <b-btn
                    :disabled="sending"
                    @click="requestLive"
                    variant="success"
                    block
                    class="mt-2"
                    size="lg"
                    pill
                >
                    Request Creator to Go Live
                </b-btn>
            </div>
        </b-alert>
        <user-between-status v-else :user="profile" :alert="true" />
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import UserBetweenStatus from "@/components/user/UserBetweenStatus";

export default {
    data() {
        return {
            sending: false,
            requestedLive: false,
        };
    },
    computed: {
        enableRequestLive() {
            return (
                this.brand.enableCreatorLivestream &&
                this.profile.creator &&
                this.isUserOnline(this.profile.id) &&
                !this.userIsLive(this.profile.id)
            );
        },
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
        ...mapState("brand", ["brand"]),
        ...mapGetters("onlinePresence", ["isUserOnline"]),
        ...mapGetters("pusher", ["userIsLive"]),
        ...mapState("profile", ["profile"]),
    },
    methods: {
        requestLive() {
            this.sending = true;

            this.api
                .post(`/profile/${this.profile.id}/requestLive`)
                .then(() => {
                    this.requestedLive = true;
                })
                .catch(() => {})
                .then(() => {
                    this.sending = false;
                });
        },
    },
    components: {
        UserBetweenStatus,
    },
};
</script>